import { render, staticRenderFns } from "./ScoringQueue.vue?vue&type=template&id=1af81444&scoped=true"
import script from "./ScoringQueue.vue?vue&type=script&lang=js"
export * from "./ScoringQueue.vue?vue&type=script&lang=js"
import style0 from "./ScoringQueue.vue?vue&type=style&index=0&id=1af81444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af81444",
  null
  
)

export default component.exports